import { render, staticRenderFns } from "./Accordeon.vue?vue&type=template&id=431eb180&scoped=true"
import script from "./Accordeon.vue?vue&type=script&lang=js"
export * from "./Accordeon.vue?vue&type=script&lang=js"
import style0 from "./Accordeon.vue?vue&type=style&index=0&id=431eb180&prod&scoped=true&lang=css"
import style1 from "./Accordeon.vue?vue&type=style&index=1&id=431eb180&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431eb180",
  null
  
)

export default component.exports